module.exports = __webpack_public_path__ + "img/icon_5_70.6ad75ae6.png";